import { authClient } from "@/shared/lib/axios";
import {
	type DashboardRuntimePayload,
	DashboardRuntimePayloadSchema,
} from "./dashboard-runtime.types";

export const dashboardRuntimeApi = {
	getSource: async (workflowId: string): Promise<DashboardRuntimePayload> => {
		const { data } = await authClient.get(`/workflows/${workflowId}/dashboard`);
		return DashboardRuntimePayloadSchema.parse({
			code: data.dashboard ?? "",
		});
	},
};
